<div
  class="custom-dropdown"
  dropdownClass="dropdown-std"
  ngbDropdown
  [container]="'body'"
>
  <div
    class="d-flex align-items-center justify-content-center pointer"
    id="dropdownMoreAction"
    ngbDropdownToggle
  >
    <span class="fal fa-ellipsis-v fa-lg"></span>
  </div>
  <div
    class="dropdown-menu"
    [ngStyle]="{ 'min-width.rem': customMinWidth }"
    aria-labelledby="dropdownMoreAction"
    ngbDropdownMenu
  >
    <ng-template #insideBtn let-iconPath="iconPath" let-text="text">
      <svg
        class="icon-size-res"
        stroke-width="1.5"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <use [attr.href]="iconPath"></use>
      </svg>
      <span class="fs-base-l0 ms-2">{{ text | translate }}</span>
    </ng-template>

    @for (action of actions; track action) {
      @if (action.condition()) {
        <button
          class="d-flex align-items-center"
          ngbDropdownItem
          [title]="action.title | translate"
          type="button"
          (click)="action.click()"
        >
          <ng-container
            [ngTemplateOutlet]="insideBtn"
            [ngTemplateOutletContext]="{
              iconPath: action.iconPath,
              text: action.title,
            }"
          >
          </ng-container>
        </button>
      }
    }

    @if (showFolderMenu) {
      <div>
        <app-move-to-folder
          [mode]="'addToFolder'"
          [filterWithPermission]="2"
          [disabledFolders]="memo?.in_folder_ids || []"
          [buttonTitle]="'MEMOS.ACTION-BUTTON-DETAIL.Add to Folder'"
          [buttonIcon]="'/assets/images/icons/files/folder-plus.svg#folder-plus'"
          [itemId]="memo?.id || 0"
        ></app-move-to-folder>
      </div>
    }
  </div>
</div>
